import SeoHead from '../../components/feature/SeoHead';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'Desguace en Viladecans – Compra de Coches',
  description: 'Compramos coches en Viladecans al mejor precio. Siniestrados, averiados, sin ITV. Recogida gratuita y pago inmediato.',
  provider: {
    '@type': 'AutoDealer',
    name: 'Desguace Barcelona',
    telephone: '+34932932913',
    address: { '@type': 'PostalAddress', addressLocality: 'Viladecans', addressRegion: 'Cataluña', addressCountry: 'ES' },
  },
  areaServed: { '@type': 'City', name: 'Viladecans' },
  url: `${siteUrl}/desguace-viladecans`,
};

export default function DesguaceViladecansPage() {
  const whatsappNumber = '932932913';
  const whatsappMessage = encodeURIComponent('Hola, estoy en Viladecans y quiero vender mi coche. ¿Podéis darme un presupuesto?');

  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="Desguace en Viladecans | Vende tu Coche al Mejor Precio | Recogida Gratis"
        description="Desguace en Viladecans. Compramos coches siniestrados, averiados o sin ITV al mejor precio. Recogida gratuita en Viladecans y Baix Llobregat. Pago inmediato."
        keywords="desguace Viladecans, vender coche Viladecans, compra coches Viladecans, desguace Baix Llobregat"
        canonical={`${siteUrl}/desguace-viladecans`}
        jsonLd={jsonLd}
      />
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-teal-500 via-teal-600 to-teal-700 text-white py-20 px-6">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
        <div className="max-w-4xl mx-auto text-center relative z-10">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Desguace en Viladecans
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-teal-50">
            Compramos tu coche en cualquier estado. Recogida gratis y pago al instante en Viladecans.
          </p>
          <a
            href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-white text-teal-600 px-8 py-4 rounded-full text-lg font-semibold hover:bg-teal-50 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            Llama al 932 932 913
          </a>
        </div>
      </section>

      {/* Zonas de Viladecans */}
      <section className="py-16 px-6 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">
            Servicio en todas las zonas de Viladecans
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {[
              'Centre',
              'Eixample',
              'La Plana',
              'Can Calderon',
              'Montserrat',
              'Torre Roja',
              'Atrium',
              'Marina Parc',
              'Can Guardiola',
              'Montigalà',
              'Sant Jordi',
              'La Gavarra'
            ].map((zona) => (
              <div
                key={zona}
                className="bg-white p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow text-center border border-gray-100"
              >
                <i className="ri-map-pin-line text-2xl text-teal-600 mb-2"></i>
                <p className="text-gray-700 font-medium">{zona}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Ventajas */}
      <section className="py-16 px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">
            ¿Por qué elegirnos en Viladecans?
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition-shadow border border-gray-100">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6 mx-auto">
                <i className="ri-money-euro-circle-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold mb-4 text-center text-gray-800">Pago Inmediato</h3>
              <p className="text-gray-600 text-center">
                Te pagamos al momento en efectivo o transferencia. Sin esperas ni complicaciones.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition-shadow border border-gray-100">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6 mx-auto">
                <i className="ri-truck-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold mb-4 text-center text-gray-800">Recogida Gratis</h3>
              <p className="text-gray-600 text-center">
                Vamos a cualquier zona de Viladecans a recoger tu coche sin coste adicional.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition-shadow border border-gray-100">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6 mx-auto">
                <i className="ri-file-text-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold mb-4 text-center text-gray-800">Gestión Completa</h3>
              <p className="text-gray-600 text-center">
                Nos encargamos de toda la documentación y trámites de baja del vehículo.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Tipos de Coches */}
      <section className="py-16 px-6 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">
            Compramos todo tipo de coches en Viladecans
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { icon: 'ri-car-line', title: 'Coches Averiados', desc: 'Con problemas mecánicos o eléctricos' },
              { icon: 'ri-alert-line', title: 'Coches Accidentados', desc: 'Siniestrados o con daños graves' },
              { icon: 'ri-file-damage-line', title: 'Sin ITV', desc: 'Caducada o sin posibilidad de pasar' },
              { icon: 'ri-time-line', title: 'Coches Antiguos', desc: 'Vehículos de cualquier antigüedad' }
            ].map((tipo) => (
              <div
                key={tipo.title}
                className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow text-center border border-gray-100"
              >
                <div className="w-14 h-14 bg-teal-100 rounded-full flex items-center justify-center mb-4 mx-auto">
                  <i className={`${tipo.icon} text-2xl text-teal-600`}></i>
                </div>
                <h3 className="font-bold text-gray-800 mb-2">{tipo.title}</h3>
                <p className="text-sm text-gray-600">{tipo.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section className="py-16 px-6 bg-gradient-to-br from-teal-600 to-teal-700 text-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            ¿Tienes un coche para vender en Viladecans?
          </h2>
          <p className="text-xl mb-8 text-teal-50">
            Contáctanos ahora y te daremos un presupuesto sin compromiso
          </p>
          <a
            href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-white text-teal-600 px-8 py-4 rounded-full text-lg font-semibold hover:bg-teal-50 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            Contactar por WhatsApp
          </a>
        </div>
      </section>
    </div>
  );
}
